import { getCustomer, getCustomerOrder } from './get-customer';

const addBuyLink = (button, link, copy) => {
    button.href = link;
    button.innerHTML = copy;
    button.classList.remove('fx-buy-button__loading'); 
}

const userLicenceCheck = async (button, cartUrl) => {
    const user = await getCustomer();

    if(!user) {
        return addBuyLink(button, cartUrl, fx_local_scripts.buy_label);
    }

    const {variant, type} = button.dataset;

    const getOrderLink = await getCustomerOrder(user, variant, type);

    if(!getOrderLink) {
        return addBuyLink(button, cartUrl, fx_local_scripts.buy_label);
    }

    return addBuyLink(button, getOrderLink, fx_local_scripts.view_purchase_label);
    
}

const setBuyLink = async (button) => {
    const {variant, cartUrl} = button.dataset;

    if(variant) {
        return await userLicenceCheck(button, cartUrl);
    }

    return addBuyLink(button, cartUrl, fx_local_scripts.buy_label);
}


export const buyButtons = async () => {
    const buyButtons = document.querySelectorAll(
        ".fx-buy-button"
    );

    buyButtons.forEach((button) => {
        setBuyLink(button);
    });
};